<kal-tab-group [formGroup]="form"
               class="gup-C-filterCard">

    <!-- onglet identité -->
    <kal-tab [label]="identityLabel" formGroupName="Identite">
        <div class="gup-C-filterCard identite">
            <section class="--tiers --without-separator">

                <article>
                    <kal-form-field>
                        <kal-input formControlName="NomBenef" label="Nom"></kal-input>
                    </kal-form-field>
                    <kal-form-field>
                        <kal-input formControlName="PrenomBenef" label="Prénom"></kal-input>
                    </kal-form-field>
                    <kal-form-field>
                        <kal-input formControlName="Matricule" label="Matricule"></kal-input>
                    </kal-form-field>
                </article>

                <article>
                    <!--
                    on met l'id entre crochet pour l'interpolation afin
                    qu'elle disparaisse lors de l'interprétation de la balise
                    -->
                    <app-date-range [id]="'beneficiary_list_date-naissance'"
                                    controlLabel="Date de naissance"
                                    formControlName="DateNaissance"></app-date-range>
                    <ng-container
                        *ngTemplateOutlet="listTemplate; context: {code: 'SEX', label: 'Genre', control: 'Identite.Sexe', multiple: false}"></ng-container>
                    <app-date-range
                        [id]="'beneficiary_list_date-creation'"
                        controlLabel="Date de création"
                        formControlName="DateCreation"></app-date-range>

                </article>

                <article></article>
            </section>
        </div>
    </kal-tab>

    <!-- onglet coordonnées -->
    <kal-tab [label]="coordinatesLabel" formGroupName="Coordonnees">

        <div class="gup-C-filterCard">

            <section class="--tiers --without-separator">

                <article>

                    <kal-form-field>
                        <kal-input formControlName="Adresse" label="Adresse"></kal-input>
                    </kal-form-field>

                    <kal-form-field>
                        <kal-input formControlName="CodePostal" label="Code postal"></kal-input>
                    </kal-form-field>

                    <kal-form-field>
                        <kal-input formControlName="Ville" label="Ville"></kal-input>
                    </kal-form-field>

                </article>

                <article>

                    <kal-form-field>
                        <kal-input formControlName="Telephone" label="Téléphone"></kal-input>
                    </kal-form-field>

                    <kal-form-field>
                        <kal-input formControlName="Email" label="E-Mail"></kal-input>
                    </kal-form-field>

                </article>

            </section>

        </div>

    </kal-tab>

    <!-- onglet critères -->
    <kal-tab [label]="criteriasLabel" formGroupName="Criteres">

        <app-date-range [id]="'beneficiary_list_date-embauche'"
                        controlLabel="Date d'embauche"
                        formControlName="DateEmbauche">
        </app-date-range>

        <kal-form-field class="without-label">

            <kal-checkbox formControlName="AfficheClotures"
                          label="Afficher les éléments archivés dans les listes ci-dessous">
            </kal-checkbox>

        </kal-form-field>

        <div class="gup-C-filterCard">

            <section class="--tiers">

                <article>

                    <ng-container
                        *ngTemplateOutlet="listTemplate;
                            context: {code: 'CTRAT', label: 'Contrat', control: 'Criteres.Contrat', multiple: true}">
                    </ng-container>

                    <ng-container
                        *ngTemplateOutlet="listTemplate;
                            context: {code: 'GROUP', label: 'Groupe', control: 'Criteres.Groupes', multiple: true}">
                    </ng-container>

                    <kal-form-field>

                        <kal-select formControlName="IsCriteresSociauxValides"
                                    label="Critères sociaux validés">
                            <kal-option [value]="null">Tous</kal-option>
                            <kal-option [value]="true">Oui</kal-option>
                            <kal-option [value]="false">Non</kal-option>
                        </kal-select>

                    </kal-form-field>

                </article>

                <article>

                    <ng-container
                        *ngTemplateOutlet="listTemplate;
                            context: {code: 'METIER', label: 'Métier', control: 'Criteres.Metier', multiple: true}">
                    </ng-container>

                    <!-- Liste des organisations -->
                    <kal-form-field>

                        <ng-template kalFormFieldLabel>Organisation</ng-template>

                        <kal-select disableFirstOptionSelection
                                    formControlName="FiltreOrganisation"
                                    multiple
                                    placeholder="Toutes">
                            <kal-option *ngFor="let value of filteredOrganisations"
                                        [value]="value.Id">
                                {{ value.Nom }}
                            </kal-option>
                        </kal-select>

                    </kal-form-field>

                </article>

                <article>

                    <!-- Liste des sites -->
                    <kal-form-field>

                        <ng-template kalFormFieldLabel>Site</ng-template>

                        <kal-select disableFirstOptionSelection
                                    formControlName="FiltresSite"
                                    multiple
                                    placeholder="Tous">
                            <kal-option *ngFor="let value of filteredSites"
                                        [value]="value.Id">
                                {{ value.Nom }}
                            </kal-option>
                        </kal-select>

                    </kal-form-field>

                    <ng-container
                        *ngTemplateOutlet="listTemplate;
                             context: {code: 'CATEG', label: 'Catégorie', control: 'Criteres.Categorie', multiple: true}">
                    </ng-container>

                </article>

            </section>

        </div>

    </kal-tab>

    <!-- onglet champs personnalisés -->
    <kal-tab [label]="personalizedFieldLabel" formArrayName="ChampsPersonnalises">

        <div class="gup-C-filterCard">

            <section class="--demi --without-separator">

                <article *ngFor="let field of personnalFields; index as index">

                    <kal-form-field>

                        <ng-template kalFormFieldLabel>{{ field.Libelle }}</ng-template>

                        <ng-container [ngSwitch]="field.ChampTypeDonnee.Code">
                            <!-- Boolean -->
                            <kal-radio-group *ngSwitchCase="fieldsTypesCodes.BOO" [formControlName]="index">
                                <kal-radio [value]="true">Oui</kal-radio>
                                <kal-radio [value]="false">Non</kal-radio>
                                <kal-radio [value]="null">Tous</kal-radio>
                            </kal-radio-group>

                            <!-- Texte -->
                            <kal-input *ngSwitchCase="fieldsTypesCodes.TXT" [formControlName]="index">
                            </kal-input>

                            <!-- Numeric -->
                            <kal-input *ngSwitchCase="fieldsTypesCodes.NUM" [formControlName]="index"
                                       defaultValue=""
                                       type="number">
                            </kal-input>

                            <!-- Date -->
                            <kal-datepicker *ngSwitchCase="fieldsTypesCodes.DAT" [formControlName]="index">
                            </kal-datepicker>

                            <!-- Liste de valeur -->
                            <kal-select *ngSwitchCase="fieldsTypesCodes.LST"
                                        [formControlName]="index"
                                        disableFirstOptionSelection
                                        multiple
                                        placeholder="Tous">
                                <kal-option *ngFor="let value of getValeursNonClotures(field)"
                                            [value]="value.Id"
                                >{{ value.Valeur }}
                                </kal-option>
                            </kal-select>
                        </ng-container>

                    </kal-form-field>

                </article>

            </section>

        </div>

    </kal-tab>

    <!--onglet ayants-droits-->
    <kal-tab [label]="ayantDroitLabel" formGroupName="AyantsDroits">

        <div class="gup-C-filterCard">

            <section class="--demi --without-separator">

                <article>

                    <kal-form-field>
                        <kal-input formControlName="NomAD" label="Nom de l'ayant droit"></kal-input>
                    </kal-form-field>

                    <kal-form-field>
                        <kal-input formControlName="PrenomAD" label="Prénom de l'ayant droit"></kal-input>
                    </kal-form-field>

                    <kal-form-field>

                        <kal-select formControlName="Enfants"
                                    label="Enfants"
                                    multiple
                                    placeholder="Tous">
                            <kal-option [value]="EnfantsTypeEnum.HaveEnfantACharge">A charge</kal-option>
                            <kal-option [value]="EnfantsTypeEnum.HaveEnfantRattache">Rattachés</kal-option>
                            <kal-option [value]="EnfantsTypeEnum.HaveEnfantHandicape">Handicapés</kal-option>
                        </kal-select>

                    </kal-form-field>

                    <kal-form-field>

                        <kal-select formControlName="IsConjointValide"
                                    label="Conjoint validé">
                            <kal-option [value]="null">Tous</kal-option>
                            <kal-option [value]="true">Oui</kal-option>
                            <kal-option [value]="false">Non</kal-option>
                        </kal-select>

                    </kal-form-field>

                </article>

                <article>

                    <kal-form-field class="ageEnfant">

                        <label>A des enfants âgés de</label>

                        <kal-input [defaultValue]="null"
                                   formControlName="AgeMinAyantDroit"
                                   type="number">
                        </kal-input>

                        <label>ans à</label>

                        <kal-input [defaultValue]="null"
                                   formControlName="AgeMaxAyantDroit"
                                   type="number"
                        ></kal-input>

                        <label>ans.</label>

                    </kal-form-field>

                    <ng-container
                        *ngTemplateOutlet="listTemplate; context: {code: 'CYCLE', label: 'Cycle scolaire', control: 'AyantsDroits.IdCycleScolaire', multiple: false}">
                    </ng-container>

                    <kal-form-field>

                        <kal-select formControlName="IsEnfantValide"
                                    label="Enfants validés">
                            <kal-option [value]="null">Tous</kal-option>
                            <kal-option [value]="true">Oui</kal-option>
                            <kal-option [value]="false">Non</kal-option>
                        </kal-select>

                    </kal-form-field>

                    <kal-form-field>

                        <kal-select formControlName="IsExterneValide"
                                    label="Externe validé">
                            <kal-option [value]="null">Tous</kal-option>
                            <kal-option [value]="true">Oui</kal-option>
                            <kal-option [value]="false">Non</kal-option>
                        </kal-select>

                    </kal-form-field>

                </article>

            </section>

        </div>

    </kal-tab>

    <!-- onglet synchronisation -->
    <!-- N'est pas fonctionnel dans la G+, à décommenter lorsque ce seras implémenté -->
    <!--            <kal-tab formGroupName="Synchronisation" [label]="synchronisationLabel">-->

    <!--                <kal-form-field class="without-label gup-C-formFieldSize&#45;&#45;bottomNull">-->
    <!--                    <kal-checkbox formControlName="VoirBenefNonSynchro"-->
    <!--                                  label="Voir les bénéficiaires non synchronisés"></kal-checkbox>-->
    <!--                </kal-form-field>-->

    <!--                <kal-form-field class="without-label gup-C-formFieldSize&#45;&#45;bottomNull">-->
    <!--                    <kal-checkbox formControlName="VoirBenefSubNonSynchro"-->
    <!--                                  label="Voir les bénéficiaires ayant des subventions non synchronisées"></kal-checkbox>-->
    <!--                </kal-form-field>-->

    <!--                <kal-form-field class="without-label gup-C-formFieldSize&#45;&#45;bottomNull">-->
    <!--                    <kal-checkbox formControlName="VoirBenefSansProfilKalidea"-->
    <!--                                  label="Voir les bénéficiaires sans profil KALIDEA"></kal-checkbox>-->
    <!--                </kal-form-field>-->

    <!--                <kal-form-field class="without-label gup-C-formFieldSize&#45;&#45;bottomNull">-->
    <!--                    <kal-checkbox formControlName="VoirBenefEnErreur"-->
    <!--                                  label="Voir les bénéficiaires non synchronisés ou avec des subventions non synchronisées"></kal-checkbox>-->
    <!--                </kal-form-field>-->

    <!--            </kal-tab>-->

</kal-tab-group>

<!-- template fonctionnel -->
<ng-template #listTemplate [formGroup]="form" let-code="code" let-control="control" let-label="label"
             let-multiple="multiple">
    <kal-form-field>
        <!-- on affiche uniquement le select si il y'a au moins un champs-->
        <ng-container *ngIf="getFieldsList(code) as fields">
            <kal-select [formControl]="$any(form.get(control))"
                        [label]="label"
                        [multiple]="multiple"
                        [placeholder]="multiple ? 'Tous' : 'Sélectionner une valeur'"
                        disableFirstOptionSelection>
                <kal-option *ngIf="!multiple" [value]="null">Tous</kal-option>
                <kal-option *ngFor="let value of fields" [value]="value.Id">
                    {{ value.Valeur }}
                </kal-option>
            </kal-select>
        </ng-container>
    </kal-form-field>
</ng-template>
